export default __webpack_public_path__ + "static/media/t32.ea60a4cf.jpg";